import { apiClient } from "../../admin/api/apiClient";

import {
  ApiResponse,
  FAQ,
  CreateFAQRequest,
  UpdateFAQRequest
} from "../../admin/interfaces/FAQ";

// ======================================
// FAQ SERVICE
// ======================================

export const faqService = {

 

  // ======================================
  // GET ACTIVE ALL
  // ======================================

  getActiveAll: async (): Promise<FAQ[]> => {

   
      const response =
  await apiClient.get<
    ApiResponse<FAQ>
  >(
    "/Public/GetActiveAllFAQ"
  );

    const result =
      response.data;
console.log(response,"check api data");
    if (!result.isSuccess) {

      throw new Error(
        result.message
      );
    }

    return result.dataList || [];
  },

 
}



  